<script setup>
/**
 * FormNavAndForm
 * A layout wrapper that arranges the form components into a 3-column structure:
 * 1. Left Sidebar: Navigation anchors for jumping between fieldsets.
 * 2. Center: The primary form fields.
 * 3. Right Sidebar: Action buttons (Archive, Duplicate, History) and record info.
 */
import SidebarToggle from '@/common/sidebar-toggle/SidebarToggle';
import FormFieldsetAnchors from './FormFieldsetAnchors';
import Form from './Form';
import FormSidebar from './FormSidebar';

defineProps({
    formId: {
        type: String,
        required: true
    },
    showArchiveBtn: Boolean,
    showDuplicateBtn: Boolean,
    showHistoryBtn: Boolean,
    showSaveAndCloseBtn: Boolean,
    showSaveBtn: Boolean,
});
</script>

<template>
    <SidebarToggle name="form_nav" class="flex-grow-1 overflow-auto">
        <template #leftSidebar>
            <FormFieldsetAnchors :form-id="formId"/>
        </template>

        <Form
            :form-id="formId"
            :show-field-names="true"
            :show-legends="true"
            class="container-fluid mt-4 mb-5"
        />

        <template #rightSidebar>
            <FormSidebar
                :form-id="formId"
                :show-archive-btn="showArchiveBtn"
                :show-duplicate-btn="showDuplicateBtn"
                :show-history-btn="showHistoryBtn"
                class="p-3"
            />
        </template>
    </SidebarToggle>
</template>